<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_1"><strong>* the toddler café *</strong></a></p><a id="page_1">
</a><p class="image"><a id="page_1"></a><a id="page_2"><img alt="Image" src="images/f0002-01.jpg"/></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?46d3c299